import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Thumb/ShopEditor';
import { Props } from '../ThumbView';

import s from './Commission.scss';

const CommissionThumbReactView: React.FC<Props> = props => (
  <div className={s['root']} style={{ width: props.width, height: props.height }}>
    <MinimalDumbo {...props} addLink={false} />
  </div>
);
CommissionThumbReactView.displayName = 'CommissionThumbReactView';

export default CommissionThumbReactView;
